import { z } from 'zod';

/**
 * Canonical actor roles persisted on `audit_logs.actor_role`.
 * Broader than {@link BookingTransitionActor} — includes VIEWER/USER for
 * platform-wide audit events (playback, registration, re-auth, etc.).
 */
export const AuditActorRole = {
  HOST: 'HOST',
  VENDOR: 'VENDOR',
  ADMIN: 'ADMIN',
  SYSTEM: 'SYSTEM',
  VIEWER: 'VIEWER',
  USER: 'USER',
} as const;
export type AuditActorRole = (typeof AuditActorRole)[keyof typeof AuditActorRole];

export const AuditActorRoleSchema = z.enum([
  AuditActorRole.HOST,
  AuditActorRole.VENDOR,
  AuditActorRole.ADMIN,
  AuditActorRole.SYSTEM,
  AuditActorRole.VIEWER,
  AuditActorRole.USER,
]);
